import { sbaAxios } from "../utils/sbaAxios";
import { getAssetShareClassddl, getAssetShareClassdetails, getAssetShareClassFeedetails } from "../../config/apiConfig";
import {
  FETCH_ASSETSHARECLASS_BEGIN,
  FETCH_ASSETSHARECLASS_SUCCESS,
  FETCH_ASSETSHARECLASS_FAILURE,

  FETCH_ASSETSHARECLASSDETAILS_BEGIN,
  FETCH_ASSETSHARECLASSDETAILS_SUCCESS,
  FETCH_ASSETSHARECLASSDETAILS_FAILURE,

  FETCH_ASSETSHARECLASSFEEDETAILS_BEGIN,
  FETCH_ASSETSHARECLASSFEEDETAILS_SUCCESS,
  FETCH_ASSETSHARECLASSFEEDETAILS_FAILURE
} from '../constants/assetShareclass';

// get ShareClass by AssetId ..

export const getShareClassbyAssetId = (AssetId, IsdefaultClassFirst) => {
  return (dispatch) => {
      dispatch(fetchshareclassBegin());
      sbaAxios({
          url: `${getAssetShareClassddl}${AssetId},${IsdefaultClassFirst}`,
          method: 'get',
      })
      .then((repos) => {
        const ShareClass = repos;
        //Add logic to format the DataItem if needed using map
        dispatch(fetchshareclassSuccess(ShareClass));
        return ShareClass;
      })
      .catch((error) => dispatch(fetchshareclassFailure(error)));
  };
}

export const fetchshareclassBegin = () => ({
  type: FETCH_ASSETSHARECLASS_BEGIN,
});

export const fetchshareclassSuccess = (assetShareClass) => ({

  type: FETCH_ASSETSHARECLASS_SUCCESS,
  payload: { assetShareClass },
});
export const fetchshareclassFailure = (errorMessage) => ({
  type: FETCH_ASSETSHARECLASS_FAILURE,
  payload: { errorMessage }
});


// get ShareClassdetails by shareclassID ..

export const getShareClassdetails = (ShareClassId) => {
  if (ShareClassId !== null) {
    return (dispatch) => {
        dispatch(fetchshareclassdetailsBegin());
        sbaAxios({
            url: `${getAssetShareClassdetails}${ShareClassId}`,
            method: 'get',
        })
        .then((repos) => {
          const ShareClass = repos;
          //Add logic to format the DataItem if needed using map
          dispatch(fetchshareclassdetailsSuccess(ShareClass));
          return ShareClass;
        })
        .catch((error) => dispatch(fetchshareclassdetailsFailure(error)));
    };
  }
  else {
    return (dispatch) => {
      dispatch(fetchshareclassdetailsBegin());
      const ShareClass = [
        {
          "ShareClassId": null,
          "ShareClassName": "NA",
          "IsDefault": false,
          "InceptionDate": null,
          "EffectiveDate": new Date(),
          "MinInvestment": 'NA',
          "SubscriptionFrequencyId": null,
          "SubscriptionFrequencyName": "NA",
          "SubscriptionCurrencyIdList": [],
          "TaxReportingId": null,
          "TaxReportingName": null,
          "VotingShares": false,
          "NewIssues": false,
          "TrackingFrequencyId": null,
          "TrackingFrequencyName": "NA",
          "TrackingById": null,
          "TrackingByName": null,
          "Accredited": false,
          "QualifiedPurchaser": false,
          "QualifiedClient": false,
          "InitialNAV": null,
          "BusinessDays": false
        }
      ];
      dispatch(fetchshareclassdetailsSuccess(ShareClass));
      return ShareClass;
    };
  }
}

export const fetchshareclassdetailsBegin = () => ({
  type: FETCH_ASSETSHARECLASSDETAILS_BEGIN,
});

export const fetchshareclassdetailsSuccess = (shareClassData) => ({

  type: FETCH_ASSETSHARECLASSDETAILS_SUCCESS,
  payload: { shareClassData },
});
export const fetchshareclassdetailsFailure = (errorMessage) => ({
  type: FETCH_ASSETSHARECLASSDETAILS_FAILURE,
  payload: { errorMessage }
});

// get ShareClassFeedetails by shareclassID ..

export const getShareClassFeedetails = (ShareClassId) => {
 if(ShareClassId!==null)
 {
  return (dispatch) => {
      dispatch(fetchshareclassfeedetailsBegin());
      sbaAxios({
          url: `${getAssetShareClassFeedetails}${ShareClassId}`,
          method: 'get',
      })
      .then((repos) => {
        const ShareClassFee = repos;
        //Add logic to format the DataItem if needed using map
        dispatch(fetchshareclassfeedetailsSuccess(ShareClassFee));
        return ShareClassFee;
      })
      .catch((error) => dispatch(fetchshareclassfeedetailsFailure(error)));
  };
}
else{
  return (dispatch) => {
    dispatch(fetchshareclassfeedetailsBegin());
        const ShareClassFee = [{
          "ShareClassFeeId": null,
          "ShareClassId": null,
          "MgmtFeeTierId": 0,
          "MgmtFeeTierDesc": null,
          "MgmtFee": null,
          "MgmtFeeFrequencyId": null,
          "MgmtFeeFrequencyName": "NA",
          "IsMgmtFeeFreqPassThrough": false,
          "PerfFeeTierId": 0,
          "PerfFeeTierDesc": null,
          "PerfFee": null,
          "PerfFeePaymentFrequencyId": null,
          "PerfFeePaymentFrequencyName": "",
          "PerfFeeAccrualFrequencyId": null,
          "PerfFeeAccrualFrequencyName": "",
          "HurdleRateId": null,
          "HurdleRateName": "NA",
          "HurdleValue": null,
          "HurdleRateBenchMarkId": null,
          "LossRecovery": false,
          "LossRecoveryResetId": null,
          "LostRecoveryResetName": null
          }]
        dispatch(fetchshareclassfeedetailsSuccess(ShareClassFee));
        return ShareClassFee;

  };
}
}

export const fetchshareclassfeedetailsBegin = () => ({
  type: FETCH_ASSETSHARECLASSFEEDETAILS_BEGIN,
});

export const fetchshareclassfeedetailsSuccess = (shareClassFeeData) => ({

  type: FETCH_ASSETSHARECLASSFEEDETAILS_SUCCESS,
  payload: { shareClassFeeData },
});
export const fetchshareclassfeedetailsFailure = (errorMessage) => ({
  type: FETCH_ASSETSHARECLASSFEEDETAILS_FAILURE,
  payload: { errorMessage }
});